<div class="subBlockContainer entry-loader" id="orderitemdetail">
  <div class="subBlockContent">
    <child-header [title]="'Order ' + orderSearch" (closeEvent)="close()"></child-header>
    <div #ParentWrapper class="child-body">
      <div class="item-title-wrapper">
        <!-- <div class="title blade-title-font">Order {{orderSearch}}
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i> -->
        <div class="page-title-description">
          Thanks for placing this order with Dicker Data. You can use this page to check all of the items you’ve
          ordered are correct, that the delivery address is correct and you can access all of the relevant
          documentation for your order as it becomes available.
        </div>
        <div class="top-divider"></div>
        <div class="row" *ngIf="loadContent">
          <div class="col-md-4">
            <div class="infoSection infoSection-detailBox-padding shadow-wrapper">
              <div class="infoSection-title-bold">SUMMARY</div>
              <div class="row infowrapper">
                <div class="col-md-6">
                  <div class="section-divider">
                    <div class="order-title">ORDER NUMBER</div>
                    <div class="order-content">{{orderDetail?.orderNo}}{{orderDetail?.orderSuffix}}</div>
                  </div>
                  <div class="section-divider">
                    <div class="order-title">RESELLER PO</div>
                    <div class="order-content">{{orderDetail?.customerRef}}</div>
                  </div>
                  <div *ngIf="orderDetail.dateInvoiced" class="section-divider">
                    <div class="order-title">INVOICE DATE</div>
                    <div>{{orderDetail?.dateInvoiced}}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="section-divider">
                    <div class="order-title">STATUS</div>
                    <div>{{orderDetail?.orderStatus}}</div>
                  </div>
                  <div class="section-divider">
                    <div class="order-title">ORDER DATE</div>
                    <div>{{orderDetail?.dateOrdered}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="infoSection infoSection-detailBox-padding shadow-wrapper">
              <div class="infoSection-title-bold">DELIVERY ADDRESS</div>
              <section class="address-wrapper" *ngIf="orderDetail?.deliveryAddress5 || orderDetail?.deliveryAddress6">
                <div *ngIf="orderDetail?.deliveryAddress1">
                  <span>{{orderDetail?.deliveryAddress1}}</span>
                </div>
                <span *ngIf="orderDetail?.deliveryAddress2">{{orderDetail?.deliveryAddress2}},
                </span>
                <span *ngIf="orderDetail?.deliveryAddress3">{{orderDetail?.deliveryAddress3}}</span>
                <span *ngIf="orderDetail?.deliveryAddress4">{{orderDetail?.deliveryAddress4}}</span>
                <div *ngIf="orderDetail?.deliveryAddress5">{{orderDetail?.deliveryAddress5}},
                  {{orderDetail?.deliveryPostCode}}</div>
                <div *ngIf="orderDetail?.deliveryAddress6">{{orderDetail?.deliveryAddress6}}
                </div>
              </section>
              <section class="address-wrapper" *ngIf="!orderDetail?.deliveryAddress5 && !orderDetail?.deliveryAddress6">
                <div class="row">
                  <div class="col-4"><img class="noData-image" src="../images/new_ui/no-deliveryLoc.png"></div>
                  <div class="col-8 noData-text">We
                    couldn't find any saved addresses for this order</div>
                </div>
              </section>
            </div>
          </div>
          <div class="col-md-4">
            <div class="infoSection infoSection-detailBox-padding shadow-wrapper">
              <div class="infoSection-title-bold">DOWNLOAD DOCUMENTS</div>
              <section *ngIf='checkDocumentAvailability()' class="row document-wrapper">
                <div class="col-md-6" *ngIf="orderDetail?.orderConfirmationUrl">
                  <a [href]="orderDetail?.orderConfirmationUrl" target="_blank" class="red-hover-link">
                    <!-- <img src="../images/new_ui/open-orders/order-confirmation-red.png" placement="bottom"
                      ngbTooltip="Order Confirmation"> -->
                    <span class="basic-icon orderConfirm-icon" placement="bottom" ngbTooltip="Order Confirmation"></span>
                    &nbsp;&nbsp;Order Confirmation
                  </a>
                </div>

                <div class="col-md-6" *ngIf="orderDetail?.creditNoteUrl">
                  <a [href]="orderDetail?.creditNoteUrl" target="_blank" class="red-hover-link">
                    <!-- <img src="../images/new_ui/open-orders/credit-note-grey.png" placement="bottom"
                      ngbTooltip="Credit Note"> -->
                    <span class="basic-icon creditNote-icon" placement="bottom" ngbTooltip="Credit Note"></span>
                    &nbsp;&nbsp;Credit Note
                  </a>
                </div>

                <div class="col-md-6" *ngIf="orderDetail?.deliveryDocketUrl">
                  <a [href]="orderDetail?.deliveryDocketUrl" target="_blank" class="red-hover-link">
                    <!-- <img src="../images/new_ui/open-orders/delivery-docket-grey.png" placement="bottom"
                      ngbTooltip="Delivery Docket"> -->
                    <span class="basic-icon deliveryDocket-icon" placement="bottom" ngbTooltip="Delivery Docket"></span>
                    &nbsp;&nbsp;Delivery Docket
                  </a>
                </div>

                <div class="col-md-6" *ngIf="orderDetail?.invoiceUrl">
                  <a [href]="orderDetail?.invoiceUrl" target="_blank" class="red-hover-link">
                    <!-- <img src="../images/new_ui/open-orders/tax-invoice-red.png" placement="bottom"
                      ngbTooltip="Tax Invoice"> -->
                    <span class="basic-icon taxInvoice-icon" placement="bottom" ngbTooltip="Tax Invoice"></span>
                    &nbsp;&nbsp;Tax Invoice
                  </a>
                </div>

                <div class="col-md-6" *ngIf="orderDetail?.licenceAgreeUrl">
                  <a [href]="orderDetail?.licenceAgreeUrl" target="_blank" class="red-hover-link">
                    <!-- <img src="../images/new_ui/open-orders/license-agreement-grey.png" placement="bottom"
                      ngbTooltip="License Agreement"> -->
                    <span class="basic-icon licenseAgreement-icon" placement="bottom"
                      ngbTooltip="License Agreement"></span>
                    &nbsp;&nbsp;License Agreement
                  </a>
                </div>

                <div class="col-md-6" *ngIf="orderDetail?.orderAmendUrl">
                  <a [href]="orderDetail?.orderAmendUrl" target="_blank" class="red-hover-link">
                    <!-- <img src="../images/new_ui/open-orders/amendment-grey.png" placement="bottom" ngbTooltip="Amendment"> -->
                    <span class="basic-icon amendment-icon" placement="bottom" ngbTooltip="Amendment"></span>
                    &nbsp;&nbsp;Amendment
                  </a>
                </div>
                <!-- <div class="col-md-6" *ngIf="orderDetail?.podUrl && shippedOrderDetail"> -->
                <div class="col-md-6" *ngIf="orderDetail?.podUrl">
                  <a [href]="orderDetail?.podUrl" target="_blank" class="red-hover-link">
                    <!-- <img src="../images/new_ui/open-orders/proof-delivery-grey.png" placement="bottom"
                      ngbTooltip="Proof of Delivery"> -->
                    <span class="basic-icon proofOfDelivery-icon" placement="bottom"
                      ngbTooltip="Proof of Delivery"></span>
                    &nbsp;&nbsp;Proof of Delivery
                  </a>
                </div>
                <!-- <div class="col-md-6" *ngIf="orderDetail?.rmaUrl && shippedOrderDetail"> -->
                <div class="col-md-6" *ngIf="orderDetail?.rmaUrl">
                  <a [href]="orderDetail?.rmaUrl" target="_blank" class="red-hover-link">
                    <!-- <img src="../images/new_ui/open-orders/return-authority-grey.png" placement="bottom"
                      ngbTooltip="Return Authority"> -->
                    <span class="basic-icon returnAuthority-icon" placement="bottom" ngbTooltip="Return Authority"></span>
                    &nbsp;&nbsp;Return Authority
                  </a>
                </div>
                <!-- <div class="col-md-6" *ngIf="orderDetail?.resellerPOUrl && shippedOrderDetail"> -->
                <div class="col-md-6" *ngIf="orderDetail?.resellerPOUrl">
                  <a [href]="orderDetail?.resellerPOUrl" target="_blank" class="red-hover-link">
                    <!-- <img src="../images/new_ui/open-orders/purchase-order-grey.png" placement="bottom"
                      ngbTooltip="Purchase Order"> -->
                    <span class="basic-icon purchaseOrder-icon" placement="bottom" ngbTooltip="Purchase Order"></span>
                    &nbsp;&nbsp;Purchase Order
                  </a>
                </div>
                <!-- <div class="col-md-6" *ngIf="orderDetail?.supportConUrl && shippedOrderDetail"> -->
                <div class="col-md-6" *ngIf="orderDetail?.supportConUrl">
                  <a [href]="orderDetail?.supportConUrl" target="_blank" class="red-hover-link">
                    <!-- <img src="../images/new_ui/open-orders/support-agreement-grey.png" placement="bottom"
                      ngbTooltip="Support Agreement"> -->
                    <span class="basic-icon supportAgreement-icon" placement="bottom"
                      ngbTooltip="Support Agreement"></span>
                    &nbsp;&nbsp;Support Agreement
                  </a>
                </div>
                <!-- <div class="col-md-6" *ngIf="orderDetail?.hasSerials =='1' && shippedOrderDetail"> -->
                <div class="col-md-6" *ngIf="orderDetail?.hasSerials =='1'">
                  <a target="_blank" (click)="exportOrderSerials(orderDetail?.orderNo, orderDetail?.orderSuffix)" class="red-hover-link">
                    <!-- <img src="../images/new_ui/open-orders/support-agreement-grey.png" placement="bottom"
                        ngbTooltip="Support Agreement"> -->
                    <span class="basic-icon orderSerials-icon" placement="bottom" ngbTooltip="Export Serials"></span>
                    &nbsp;&nbsp;Export Serials
                  </a>
                </div>
                <div class="col-md-6" *ngIf="orderDetail?.autopilotUrl">
                  <a [href]="orderDetail?.autopilotUrl" target="_blank" class="red-hover-link">
                    <!-- <img src="../images/new_ui/open-orders/credit-note-grey.png" placement="bottom"
                      ngbTooltip="Credit Note"> -->
                    <span class="basic-icon autopilot-icon" placement="bottom" ngbTooltip="Autopilot"></span>
                    &nbsp;&nbsp;Autopilot
                  </a>
                </div>
                
                <div class="col-md-6" *ngIf="orderDetail?.connoteUrl">
                  <a [href]="orderDetail?.connoteUrl" target="_blank" class="red-hover-link">
                    <!-- <img src="../images/new_ui/open-orders/delivery-docket-grey.png" placement="bottom"
                      ngbTooltip="Delivery Docket"> -->
                    <span class="basic-icon deliveryDocket-icon" placement="bottom" ngbTooltip="Connote Tracking"></span>
                    &nbsp;&nbsp;Connote Tracking
                  </a>
                </div>
              </section>
              <section *ngIf='!checkDocumentAvailability()' class="nofoundwrapper">
                <div class="row">
                  <div class="col-4"><img class="noData-image" src="../images/new_ui/no-found.png"></div>
                  <div class="col-8 noData-text">We couldn't find any
                    saved document for this order.</div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      <div class="inner-subBlock-wrapper" *ngIf="loadContent">
        <div class="mTable-header">
          <div class="filter-wrapper">
            <div class="searchInputGroup push-left">
              <div class="searchIcon">
                <img src="../images/new_ui/filter.png">
              </div>
              <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
                onblur="this.placeholder='Filter'" [(ngModel)]="filterInput">
            </div>
          </div>
        </div>
        <div class="mTable">
          <table matSort (matSortChange)="sortData($event)" class="white">
            <thead>
              <tr class="row order-title-wrapper">
                <th style="width: 60%;padding-left: 15px;" mat-sort-header="description">DESCRIPTION</th>
                <th style="width: 10%" mat-sort-header="soh">ALLOCATED QTY</th>
                <th style="width: 10%;padding-left: 25px" mat-sort-header="price">PRICE</th>
                <th style="width: 10%" mat-sort-header="orderStatus">QTY</th>
                <th style="width: 10%" mat-sort-header="holdReason">SUBTOTAL</th>
              </tr>
            </thead>
            <tbody>
              <!-- comment limitation of page display -->
              <!-- <ng-container
                *ngFor="let item of items | TableFilterMultiple: ['stockCode', 'lineDescription'] : filterInput | paginate: { itemsPerPage: 50, currentPage: p }; let i = index"> -->
              <ng-container
                *ngFor="let item of items | TableFilterMultiple: ['stockCode', 'lineDescription', 'brand', 'status', 'sku', 'soh', 'unitCostEx'] : filterInput">
                <tr class="row inforow">
                  <div style="width: 60%;padding-left:15px">
                    <div class="result_desc">
                      <a [routerLink]="['product/'+item.stockCode]" (click)="checkProductDetail(item.stockCode)">
                        <div class="result_desc">{{item?.lineDescription}}</div>
                      </a>
                    </div>
                    <div class="result-info">
                      <div class="produc-secondary-title-wrapper">
                        <span class="light-text">BRAND:&nbsp;</span>
                        <span>{{item?.brand}}</span>
                        <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                        <span class="light-text">STATUS:&nbsp;</span>
                        <span>{{item.status}}</span>
                        <span *ngIf="item?.status == 'C'">CLEARANCE</span>
                        <span *ngIf="item?.status == 'P'">PROMOTION</span>
                        <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                        <span class="light-text">SKU:&nbsp;</span>
                        <span>{{item?.stockCode}}</span>
                      </div>
                    </div>

                    <div class="result-additional-info" style="padding-bottom: 5px;">
                      <div *ngIf="item.bundledProductList?.length" class="bundle-wrapper">
                        <img class="center" src="../images/new_ui/bundle.png">
                        <div class="bold-text center">BUNDLE</div>
                      </div>

                      <div *ngIf="item.promotion && item.promotion != 'null'" class="promotion-wrapper">
                        <img class="center" src="../images/new_ui/promotion.png">
                        <div class="bold-text center">PROMOTION:</div>
                        <div class="light-text center">ENDS ON {{item.promotion}}</div>
                      </div>

                      <!-- <div class="filled-bg"
                        *ngIf="item.status != 'A' && item.status != 'C' && item.status != 'P' && item.status && item?.availableQty != 'null'"
                        [ngbTooltip]="tipContent" tooltip="Obsolete product" placement="bottom" #t="ngbTooltip">
                        <img class="center" src="../images/new_ui/attention.png">
                        <div class="bold-text center">{{item?.availableQty}} ITEMS LEFT</div>
                      </div>
                      <ng-template #tipContent>
                        <div [ngClass]="'tooltip-wrapper'">Obsolete product</div>
                      </ng-template> -->

                    </div>

                  </div>
                  <div style="width: 10%;padding-right: 75px;" class="align-center v-align-center">{{convertQty(item?.qtyAllocated)}}
                  </div>
                  <div style="width: 10%;padding-left: 25px;" class="align-left v-align-center">
                    {{item?.unitCostEx | currency:'AUD':'symbol-narrow':'.2-2'}}</div>
                  <div style="width: 10%;padding-right: 60px;" class="align-center v-align-center">{{convertQty(item?.qtyOrdered)}}
                  </div>
                  <div style="width: 10%;padding-left: 23px;" class="align-left v-align-center">
                    {{convertTotal(item?.subtotalNew) | currency:'AUD':'symbol-narrow':'.2-2'}}
                    <!-- {{item?.subtotalEx | currency:'AUD':'symbol-narrow':'.2-2'}} -->
                    <!-- <ng-container *ngIf="item.qtyOrdered?.includes('-')||item.qtyAllocated?.includes('-')">-</ng-container> -->
                  </div>
                </tr>
              </ng-container>
              <tr class="row totalPrice-wrapper">
                <div class="col-md offset-md-7">Total (ex GST)</div>
                <div class="col-md price">{{convertTotal(totalEx) | currency:'AUD':'symbol-narrow':'.2-2'}}</div>
                <!-- <div class="col-md price">{{orderDetail?.orderTotalEx | currency:'AUD':'symbol-narrow':'.2-2'}}</div> -->
              </tr>
              <tr class="row totalPrice-wrapper"
                *ngIf="(urlPath == 'openorders' || urlPath == 'backordersreport') && order?.showPayNowBtn">
                <div class="col-md offset-md-7">&nbsp;</div>
                <div class="col-md price"><button class="button button-red button-mid" (click)="payOrder()">Pay
                    now</button></div>
              </tr>
            </tbody>
          </table>
        </div>
        <!--  -->
      </div>
      <loading-screen *ngIf="!loadContent" [isScrolled]="!shippedOrderDetail" [showBlurTable]="true"></loading-screen>
    </div>
  </div>
</div>

<router-outlet></router-outlet>